export default "__VITE_ASSET__CZIxTnEP__"